export const Colors = [
    0xcf2d14,
    0xffe000,
    0x94db71,
    0x08a86a,
    0x99d1f4,
    0x5e73b6,
    0xee6aa4,
    0xebc5c4,
    0x7c2e1a,
    0x000010,
    0xb4b5ca,
    0xffffff
    // 0xf8f8f8,
    // 0xe9e2ea,
];